<mono-common-back-to-navigation-bar data-test="lmw-base-terms-back-to-home-bar-top"
[linkText]="mobileBackButtonText"
linkTo="/"
position="back-to-navigation__top">
</mono-common-back-to-navigation-bar>
<main class="grid-container site-container" aria-describedby="ariaMainHeaderId">
  <div class="grid-x grid-margin-x">
    <div class="cell" [innerHTML]="termsAndConditionsCmsData?.data?.attributes?.copy | dontSanitizeHtml"></div>
  </div>
</main>
<mono-common-back-to-navigation-bar
data-test="lmw-base-terms-back-to-home-bar-bottom"
[linkText]="mobileBackButtonText"
linkTo="/"
position="back-to-navigation__bottom"></mono-common-back-to-navigation-bar>
